<div class="shared-profile-page" *ngIf="dataLoaded">
  <div class="shared-profile-header">
    <h1>{{ 'global.your_skills_profile' | translate }}</h1>
    <lib-lang-droplist
      [noNative]="true"
      [dropdownIconsPath]="'/icons/icon-arrow-b-'"
      [triggerIcon]="'/icons/translate-icon.svg'"
    ></lib-lang-droplist>
  </div>

  <div class="single-column-layout">
    <bwh-lib-personal-data
      [form]="form"
      [cvSharing]="true"
      [editButton]="false"
      [editPhoto]="false"
    ></bwh-lib-personal-data>

    <div class="accordion-section" *ngIf="knowledgeSkills.length > 0">
      <div class="accordion-header" (click)="toggleSection('knowledge_skills')">
        <span class="accordion-title">{{ 'global.knowledge_and_skills' | translate }}</span>
        <div class="accordion-header-actions">
          <img
            class="accordion-chevron"
            [class.collapsed]="!isSectionExpanded('knowledge_skills')"
            src="/assets/icons/icon-down-b.svg"
            alt=""
          />
        </div>
      </div>
      <div class="accordion-body" *ngIf="isSectionExpanded('knowledge_skills')">
        <bwh-lib-skills-edition
          [form]="form"
          [control]="'knowledge_skills'"
          [title]="'global.knowledge_and_skills' | translate"
          [showHeader]="false"
          [cvSharing]="true"
          [blockStarClick]="true"
        ></bwh-lib-skills-edition>
      </div>
    </div>

    <div class="accordion-section" *ngIf="softSkills.length > 0">
      <div class="accordion-header" (click)="toggleSection('soft_skills')">
        <span class="accordion-title">{{ 'global.soft_skills' | translate }}</span>
        <div class="accordion-header-actions">
          <img
            class="accordion-chevron"
            [class.collapsed]="!isSectionExpanded('soft_skills')"
            src="/assets/icons/icon-down-b.svg"
            alt=""
          />
        </div>
      </div>
      <div class="accordion-body" *ngIf="isSectionExpanded('soft_skills')">
        <bwh-lib-skills-edition
          [form]="form"
          [control]="'soft_skills'"
          [title]="'global.soft_skills' | translate"
          [showHeader]="false"
          [cvSharing]="true"
          [blockStarClick]="true"
        ></bwh-lib-skills-edition>
      </div>
    </div>

    <div class="accordion-section" *ngIf="work_history.length > 0">
      <div class="accordion-header" (click)="toggleSection('work_history')">
        <span class="accordion-title">{{ 'global.your_experience' | translate }}</span>
        <div class="accordion-header-actions">
          <img
            class="accordion-chevron"
            [class.collapsed]="!isSectionExpanded('work_history')"
            src="/assets/icons/icon-down-b.svg"
            alt=""
          />
        </div>
      </div>
      <div class="accordion-body" *ngIf="isSectionExpanded('work_history')">
        <bwh-lib-skills-edition
          [form]="form"
          [control]="'work_history'"
          [editName]="'your_experience'"
          [title]="'global.your_experience' | translate"
          [showHeader]="false"
          [cvSharing]="true"
        ></bwh-lib-skills-edition>
      </div>
    </div>

    <div class="accordion-section" *ngIf="education.length > 0">
      <div class="accordion-header" (click)="toggleSection('education')">
        <span class="accordion-title">{{ 'global.your_education' | translate }}</span>
        <div class="accordion-header-actions">
          <img
            class="accordion-chevron"
            [class.collapsed]="!isSectionExpanded('education')"
            src="/assets/icons/icon-down-b.svg"
            alt=""
          />
        </div>
      </div>
      <div class="accordion-body" *ngIf="isSectionExpanded('education')">
        <bwh-lib-skills-edition
          [form]="form"
          [control]="'education'"
          [title]="'global.your_education' | translate"
          [showHeader]="false"
          [cvSharing]="true"
          [levelOptions]="levelOptions"
        ></bwh-lib-skills-edition>
      </div>
    </div>

    <div class="accordion-section" *ngIf="languages.length > 0">
      <div class="accordion-header" (click)="toggleSection('languages')">
        <span class="accordion-title">{{ 'global.languages' | translate }}</span>
        <div class="accordion-header-actions">
          <img
            class="accordion-chevron"
            [class.collapsed]="!isSectionExpanded('languages')"
            src="/assets/icons/icon-down-b.svg"
            alt=""
          />
        </div>
      </div>
      <div class="accordion-body" *ngIf="isSectionExpanded('languages')">
        <bwh-lib-skills-edition
          [form]="form"
          [control]="'languages'"
          [title]="'global.languages' | translate"
          [showHeader]="false"
          [cvSharing]="true"
          [blockStarClick]="true"
        ></bwh-lib-skills-edition>
      </div>
    </div>
  </div>
</div>
